module.exports = __webpack_public_path__ + "static/media/foto10.01f156a3.jpeg";